import React, { useEffect, useState } from "react";
import { agent } from "../../utils/agent";
import { Link } from "react-router-dom";
import Loader from "../Common/Loader";
import ShowOwnerDetail from "./ShowOwnerDetail";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
const API_URL = process.env.REACT_APP_API_URL;
const Team = () => {
  useAutoAddQueryString();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    showTeamOwner();
  }, []);

  const showTeamOwner = () => {
    setIsLoading(true);
    agent.get(API_URL + "showTeamOwner").then((res) => {
      setData(res.data.data);
      setIsLoading(false);
      return res;
    });
  };
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [ownerDetail, setOwnerDetail] = useState("");
  const [teamName, setTeamName] = useState("");
  const handleShow = (ownerDetail = "", teamName = "") => {
    setShow(true);
    setOwnerDetail(ownerDetail);
    setTeamName(teamName);
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Teams</h2>
            </div>
            <ul className="sponsor_list bonus-card">
              {data &&
                data.map((item, key) => (
                  <li key={key}>
                    <div className="sponsorslide">
                      <div className="sponsortop">
                        <div className="sponsorinfo">
                          <figure>
                            {item?.team_sponsor_logo && (
                              <img
                                src={`${process.env.REACT_APP_UPLOAD_URL}team_sponsor/${item?.team_sponsor_logo}`}
                                width="70"
                                height="70"
                                alt="img"
                              />
                            )}
                            {!item?.team_sponsor_logo &&
                              clubDetails &&
                              clubDetails?.logo && (
                                <img
                                  src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                                  width="70"
                                  height="70"
                                  alt="img"
                                />
                              )}
                          </figure>
                          <strong>{item?.name}</strong>
                          {item.team_owner && (
                            <span className="gameweektag">
                              {item?.team_owner}
                            </span>
                          )}
                          {item.owner_detail && (
                            <Link
                              className="border-btn"
                              onClick={() =>
                                handleShow(item?.owner_detail, item?.name)
                              }
                            >
                              Details
                            </Link>
                          )}
                        </div>
                      </div>
                      <div
                        className="topplayerlist"
                        style={{ maxHeight: "500px", overflowY: "auto" }}
                      >
                        <ul className="mCustomScrollbar">
                          {item?.get_team_player &&
                            item?.get_team_player.map((item1, key1) => (
                              <li key={key1}>
                                <figure>
                                  {item1?.is_avatar === 1 ? (
                                    <Link to={`/player-profile/${item1.id}`}>
                                      <img
                                        src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item1.image}`}
                                        alt="img"
                                      />
                                    </Link>
                                  ) : (
                                    <Link to={`/player-profile/${item1.id}`}>
                                      <img
                                        src={`${process.env.REACT_APP_UPLOAD_URL}player/${item1?.image}`}
                                        alt="img"
                                      />
                                    </Link>
                                  )}
                                </figure>

                                <h5>
                                  {" "}
                                  <Link to={`/player-profile/${item1.id}`}>
                                    {item1.full_name}
                                  </Link>
                                </h5>
                                <span>
                                  {item1.position_name} | ${item1.svalue}m |{" "}
                                  {item1.player_points}
                                  {" pts"}
                                </span>
                                <strong>
                                  {" "}
                                  {/* <Link
                                  onClick={() =>
                                    playerCardHandle(item1)
                                  }
                                  >
                                    <i class="fas fa-user"></i>
                                  </Link> */}
                                  <Link
                                    to={`/player-charts?player_id=${item1?.id}`}
                                  >
                                    <i class="fas fa-chart-line"></i>
                                  </Link>
                                </strong>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
      <ShowOwnerDetail
        show={show}
        handleClose={handleClose}
        ownerDetail={ownerDetail}
        teamName={teamName}
      />
    </>
  );
};

export default Team;
